import type { FieldDef, FormValues, TemplateDef } from '../../promotions/types';

export const BRIEFING_V4_PERMISSION = 'briefing-promocoes-v4';
export const COUPON_VISIBLE_KEY = 'cupomVisivelCarrinho';
export const COUPON_VISIBLE_HEADER = 'Cupom visível no carrinho?';

export const V4_REMOVED_FIELD_KEYS = new Set([
  'tipoSolicitacao', 'idIFC', 'idIfc', 'sellersExcecao',
  'skusInclusao', 'skusExclusao', 'skuCombo', 'skusObrigatorios', 'skusFamilia',
]);

export const V4_REMOVED_HEADERS = new Set([
  'Tipo de solicitação', 'ID Infracommerce', 'Sellers exceção',
  'SKUs inclusão', 'SKUs exclusão', 'SKU é combo?', 'SKUs obrigatórios', 'SKUs da família',
]);

export function isBriefingV4Enabled(permissions?: ReadonlyArray<{ name?: string }> | null): boolean {
  return Boolean(permissions?.some((feature) => feature?.name === BRIEFING_V4_PERMISSION));
}

export function isRemovedV4Field(key: string): boolean {
  return V4_REMOVED_FIELD_KEYS.has(key.replace(/__child\d+$/, ''));
}

export const couponVisibleField: FieldDef = {
  key: COUPON_VISIBLE_KEY,
  label: COUPON_VISIBLE_HEADER,
  type: 'select',
  options: [{ value: 'NÃO', label: 'NÃO' }, { value: 'SIM', label: 'SIM' }],
};

export function applyBriefingTemplateVersion(template: TemplateDef, briefingV4: boolean): TemplateDef {
  if (!briefingV4) return template;

  const sections = template.sections.map((section) => ({
    ...section,
    fields: section.fields.filter((field) => !isRemovedV4Field(field.key)).map((field) => (
      field.excludeValuesFrom && isRemovedV4Field(field.excludeValuesFrom)
        ? { ...field, excludeValuesFrom: undefined }
        : field
    )),
  })).filter((section) => section.fields.length > 0);

  if (['t5', 't6'].includes(template.id)) {
    const couponSection = sections.find((section) => section.title === 'Cupom');
    if (couponSection && !couponSection.fields.some((field) => field.key === COUPON_VISIBLE_KEY)) {
      couponSection.fields.push(couponVisibleField);
    }
  }

  return { ...template, sections };
}

export function applyBriefingValuesVersion(templateId: string, values: FormValues, briefingV4: boolean): FormValues {
  return Object.fromEntries(Object.entries(values).filter(([key]) => (
    briefingV4 ? !isRemovedV4Field(key) : key !== COUPON_VISIBLE_KEY
  )).filter(([key]) => key !== COUPON_VISIBLE_KEY || ['t5', 't6'].includes(templateId))
    .map(([key, value]) => {
      if (key !== COUPON_VISIBLE_KEY) return [key, value];
      const text = String(value).trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
      return [key, ['0', 'NAO'].includes(text) ? 'NÃO' : ['1', 'SIM'].includes(text) ? 'SIM' : value];
    }));
}
